import { CoreUiException } from "./core-ui-exception";

/**
 * Occurrs when an exception occurs in a component.
 *
 */
export class DirectiveException extends CoreUiException {

    constructor(message: string, originalError?: any) {

        super("ComponentException", message, originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, DirectiveException.prototype);
    }
}
